/* Kashmire : bouton ADD TO BAG - chargement propre (07/10).
   Pendant l'ajout au panier : le texte s'efface et un petit cercle blanc tourne, puis le texte revient.
   Remplace la barre de chargement et la coche du theme (invisibles en noir sur noir). */
(function () {
  if (window.kpAtcInit) return;
  window.kpAtcInit = true;
  var BTN = '.product-form__cart-submit';
  var lastBtn = null;
  var lastClick = 0;

  function addSpinner(btn) {
    if (!btn.querySelector('.kp-spinner')) {
      var s = document.createElement('span');
      s.className = 'kp-spinner';
      s.setAttribute('aria-hidden', 'true');
      btn.appendChild(s);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(BTN);
    if (!btn || btn.disabled) return;
    lastBtn = btn;
    lastClick = Date.now();
    addSpinner(btn);
  }, true);

  function start() {
    if (!lastBtn || Date.now() - lastClick > 3000) return null;
    var btn = lastBtn;
    lastBtn = null;
    btn.classList.add('kp-adding');
    btn.setAttribute('aria-busy', 'true');
    return { btn: btn, t: Date.now() };
  }
  function done(state) {
    if (!state) return;
    var wait = Math.max(0, 450 - (Date.now() - state.t)); // evite un clignotement trop court
    setTimeout(function () {
      state.btn.classList.remove('kp-adding');
      state.btn.removeAttribute('aria-busy');
    }, wait);
  }
  function isAdd(url) {
    return /\/cart\/add/.test(String(url || ''));
  }

  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var state = isAdd(url) ? start() : null;
      var p = _fetch.apply(this, arguments);
      if (state) p.then(function () { done(state); }, function () { done(state); });
      return p;
    };
  }
  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, url) {
    this._kpAdd = isAdd(url);
    return _open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this._kpAdd) {
      var state = start();
      this.addEventListener('loadend', function () { done(state); });
    }
    return _send.apply(this, arguments);
  };
})();

/* Kashmire : apparition douce des produits dans les grilles VERTICALES (pages collection, recherche,
   "You may also like" en onglets). Pas d'animation sur les carrousels horizontaux (08/10).
   Les cartes apparaissent rangee par rangee, de haut en bas, au fil du defilement :
   fondu + legere remontee (24px), 0,8 s, decalage de 80 ms entre cartes d'une meme vague.
   Le style est dans assets/kp-reveal.css (+ assets/kp-transitions.css pour les pages collection).
   (17/10) Pages collection : les cartes visibles a l'ouverture remontent aussi (avant, seules les cartes
   plus bas le faisaient, donc les petites collections comme Vestes ou Knitwear n'avaient aucune animation). */
(function () {
  var root = document.documentElement;
  if (!root.classList.contains('kp-reveal')) return;

  var SELECTOR = [
    '.collection__products .product-item',
    '.search__content .product-item',
    '.kp-tabs__grid .product-item'
  ].join(',');
  var STEP = 80;   // ms entre deux cartes d'une meme vague
  var MAX_STEPS = 8;
  var animateFirst = !!(document.body && document.body.classList.contains('template-collection'));

  if (!('IntersectionObserver' in window)) {
    root.classList.remove('kp-reveal');
    return;
  }

  var queue = [];
  var flushing = false;

  function flush() {
    flushing = false;
    // Ordre de lecture : de haut en bas, puis de gauche a droite
    queue.sort(function (a, b) {
      var ra = a.getBoundingClientRect();
      var rb = b.getBoundingClientRect();
      if (Math.abs(ra.top - rb.top) > 8) return ra.top - rb.top;
      return ra.left - rb.left;
    });
    queue.forEach(function (el, i) {
      el.style.setProperty('--kp-delay', Math.min(i, MAX_STEPS) * STEP + 'ms');
      el.classList.add('kp-in');
      // Nettoyage apres l'animation pour ne pas gener les effets de survol du theme
      setTimeout(function () {
        el.classList.add('kp-done');
      }, 1000 + Math.min(i, MAX_STEPS) * STEP);
    });
    queue = [];
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      io.unobserve(entry.target);
      queue.push(entry.target);
    });
    if (queue.length && !flushing) {
      flushing = true;
      window.requestAnimationFrame(flush);
    }
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  // (12/10) Hors pages collection : les cartes deja visibles a l'ouverture s'affichent tout de suite.
  // (17/10) Pages collection : elles sont masquees des le premier affichage (kp-transitions.css) et remontent.
  var firstPass = true;
  function watch(scope) {
    var list = (scope || document).querySelectorAll(SELECTOR);
    var vh = window.innerHeight || document.documentElement.clientHeight;
    Array.prototype.forEach.call(list, function (el) {
      if (el.getAttribute('data-kp-watch')) return;
      if (firstPass && !animateFirst) {
        var r = el.getBoundingClientRect();
        if (r.top < vh && r.bottom > 0) {
          el.classList.add('kp-done');
          el.setAttribute('data-kp-watch', '1');
          return;
        }
      }
      el.setAttribute('data-kp-watch', '1');
      io.observe(el);
    });
    firstPass = false;
  }

  function start() {
    watch(document);
    // Produits ajoutes plus tard (filtres, tri, chargement automatique)
    if ('MutationObserver' in window) {
      var pending = false;
      var mo = new MutationObserver(function (mutations) {
        if (pending) return;
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
            pending = true;
            window.requestAnimationFrame(function () {
              pending = false;
              watch(document);
            });
            break;
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
    window.kpRevealReady = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();